import { playerService } from './player-service';
import { roundService } from './round-service';
import { Round, RoundStatus } from '../models/round';


class ServiceFacade {

    public async createRound(roundName: string, playerName: string) {

        try {
            // TODO: error handling
            // create player
            const playerResponse = await playerService.createPlayer(playerName);

            // create round
            const roundResponse = await roundService.createRound(roundName);

            // attach player to round.
            const attachResponse = await roundService.attachPlayerToRound(roundResponse.body.id, playerResponse.body.id);


            return {
                body: {
                    round: roundResponse.body,
                    player: {
                        id: playerResponse.body.id,
                        name: playerResponse.body.name,
                    },
                },
                status: roundResponse.status,
            };
        } catch (error) {
            console.error('Error creating round:', error);
            throw error;
        }

    }

    public async getRound(roundId: string, playerId: string) {
        try {
            const response = await roundService.getRound(roundId);

            const round: Round = response.body;
            const player = round.players.find(p => p.id === playerId);
            round.player = player;

            return round;
        } catch (error) {
            console.error('Error getting round:', error);
            throw error;
        }
    }

    public async updateScore(roundId: string, playerId: string, hole: number, score: number) {
        try {
            await roundService.recordScore(roundId, playerId, hole, score);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error updating score:', error);
            throw error;
        }
    }

    public async completeRound(roundId: string, playerId: string) {
        try {
            await roundService.updatePlayerRoundStatus(roundId, playerId, RoundStatus.COMPLETED);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error completing round:', error);
            throw error;
        }
    }

    public async editRound(roundId: string, playerId: string) {
        try {
            await roundService.updatePlayerRoundStatus(roundId, playerId, RoundStatus.IN_PROGRESS);
            return await this.getRound(roundId, playerId);
        } catch (error) {
            console.error('Error completing round:', error);
            throw error;
        }
    }
}

export const serviceFacade = new ServiceFacade();